const getCalendarData = (state) => { return state.calendarData }

const getIsLoading = (state) => { return state.isLoading }

const getBookingDetails = (state) => { return state.bookingDetails }

const getBillItemDetails = (state) => { return state.billItemDetails }

const getBookingPaidStatusArray = (state) => { return state.bookingPaidStatusArray }

const getPaymentMethodsAliases = (state) => {  return JSON.parse(JSON.stringify(state.paymentMethodsAliases)) }

export default {
    getCalendarData,
    getIsLoading,
    getBookingDetails,
    getBillItemDetails,
    getBookingPaidStatusArray,
    getPaymentMethodsAliases
}
